module.exports = __webpack_public_path__ + "static/media/vandalism-animation.c3ca5689.svg";